import axios from 'axios'
import SortService from '@/services/sort.service'
import Vue from "vue"

export default {
    namespaced: true,
    state: {
        followups: [],
        followup: [],
        user_followups: [],
        filtered_followups: [],
        priorities: [
            { key: 1, value: "High" },
            { key: 2, value: "Medium" },
            { key: 3, value: "Low" }
        ],
        leads: [],
        dates: [],
        users: [],
        filter_params: [],
        necessaryDialog: false
    },
    getters: {
        followups: (state) => state.followups,
        followup: (state) => state.followup,
        user_followups: (state) => state.user_followups,
        filtered_followups: (state) => state.filtered_followups,
        priorities: (state) => state.priorities,
        leads: (state) => state.leads,
        dates: (state) => state.dates,
        users: (state) => state.users,
        filter_params: (state) => state.filter_params,
        necessaryDialog: (state) => state.necessaryDialog
    },
    mutations: {
        SET_FOLLOWUP(state, followup) {
            state.followup = followup;
        },
        SET_FOLLOWUPS(state, followups) {
            followups.forEach(item => {
                let priority;
                switch (item.priority) {
                    case 1:
                        priority = "High";
                        break;
                    case 2:
                        priority = "Medium";
                        break;
                    case 3:
                        priority = "Low";
                        break;
                }
                item.priority = priority;
            });

            state.followups = followups;
        },
        SET_LEADS(state, leads) {
            state.leads = leads;
        },
        SET_USERS(state, users) {
            state.users = users;
        },
        SET_DATES(state, dates) {
            state.dates = dates;
        },
        SET_USER_FOLLOWUPS(state, followups) {
            state.user_followups = followups;
        },
        SET_FILTERED_FOLLOWUPS(state, followups) {
            state.filtered_followups = followups;
        },
        SET_FILTER_PARAMS(state, params) {
            params.datetimeParams = SortService.sortDateToUserTimeZone(params.datetimeParams);
            state.filter_params = params;
        },
        SET_NECESSARY_DIALOG(state, status) {
            state.necessaryDialog = status;
        },
        "SOCKET_FOLLOWUP_CREATE"(state, followup) {
            followup.datetime = SortService.sortDateToUserTimeZone(followup.datetime);
            const priorityIndex = state.priorities.findIndex(item => item.key === followup.priority);
            followup.priority = state.priorities[priorityIndex].value;
            state.followups.push(followup);
        },
        "SOCKET_FOLLOWUP_DELETE"(state, followup) {
            const indexFollowup = state.followups.findIndex(item => item.id === followup.id);
            state.followups.splice(indexFollowup, 1);

            const indexAgentFollowup = state.user_followups.findIndex(item => item.id === followup.id);
            state.user_followups.splice(indexAgentFollowup, 1);
        },
        "SOCKET_FOLLOWUP_UPDATE"(state, followup) {
            const index = state.followups.findIndex(item => item.id === followup.followup.id);
            const indexUserFollowup = state.user_followups.findIndex(item => item.id === followup.user_followup.id);
            const indexFilteredFollowup = state.filtered_followups.findIndex(item => item.id === followup.user_followup.id);

            let priority;

            switch (followup.followup.priority) {
                case 1:
                    priority = "High";
                    break;
                case 2:
                    priority = "Medium";
                    break;
                case 3:
                    priority = "Low";
                    break;
            }

            followup.followup.priority = priority;
            followup.user_followup.priority = priority;

            followup.followup.datetime = SortService.sortDateToUserTimeZone(followup.followup.datetime);
            followup.user_followup.datetime_old = followup.user_followup.datetime;
            followup.user_followup.datetime = SortService.sortDateToUserTimeZone(followup.user_followup.datetime);

            state.followups[index] = followup.followup;
            state.user_followups[indexUserFollowup] = followup.user_followup;
            state.filtered_followups[indexFilteredFollowup] = followup.user_followup;

            Vue.set(state.followups, index, state.followups[index]);
            Vue.set(state.user_followups, indexUserFollowup, state.user_followups[indexUserFollowup]);
            Vue.set(state.filtered_followups, indexFilteredFollowup, state.filtered_followups[indexFilteredFollowup]);
        }
    },
    actions: {
        loadUserFollowups({ commit }, user_id) {
            return new Promise(resolve => {
                axios.get("/followup/user/" + user_id)
                    .then(res => {

                        let followups = res.data.followups;

                        followups = SortService.sortDateToUserTimeZoneInObject(res.data.followups, "datetime", true);

                        commit("SET_USER_FOLLOWUPS", followups);

                        commit("SET_DATES", followups.map(f => {
                            return { datetime: f.datetime, datetime_old: f.datetime_old };
                        }));

                        let tempArr = followups.map(item => {
                            return [item.lead_id, item];
                        });
                        tempArr = new Map(tempArr);
                        let uniqueLeads = [...tempArr.values()];

                        commit("SET_LEADS", uniqueLeads.map(f => {
                            return { fullname: f.fullname, lead_id: f.lead_id };
                        }));

                        tempArr = followups.map(item => {
                            return [item.user_id, item];
                        });
                        tempArr = new Map(tempArr);
                        let uniqueUsers = [...tempArr.values()];

                        commit("SET_USERS", uniqueUsers.map(f => {
                            return { agentName: f.agentName, user_id: f.user_id };
                        }));
                        resolve(followups);
                    })
                    .catch(err => console.log(err));
            });
        },
        loadFollowups({ commit }, lead_id) {
            axios.get('/followup/' + lead_id)
                .then(res => {
                    commit("SET_FOLLOWUPS", SortService.sortDateToUserTimeZoneInObject(res.data.followups, "datetime"));
                })
                .catch(err => {
                    console.error(err);
                });
        },
        loadFollowupsByFilters({ commit }, { params, user_id }) {
            axios.post('/followup/filter', {
                params: params,
                user_id: user_id,
            })
                .then(res => {
                    commit("SET_FILTERED_FOLLOWUPS", SortService.sortDateToUserTimeZoneInObject(res.data.followups, "datetime"));
                })
                .catch(err => {
                    console.error(err);
                });
        },
        loadFilterParams({ commit }, user_id) {
            axios.get("/followup/filter-params/" + user_id).then(res => commit("SET_FILTER_PARAMS", res.data.params)).catch(err => console.log(err));
        }
    },

};
